import Request from ".";
import { Routes } from "../constant/api_url";

const insertProductApi = async (data) => {
  try {
    const result = await Request.post(Routes.ADDPRODUCTITEM, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateProductApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRODUCTITEM, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getProductApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRODUCTITEM, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteProductApi = async (data) => {
  try {
    const result = await Request.delete(Routes.DELETEPRODUCTITEM, { data });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export { insertProductApi, updateProductApi, getProductApi, deleteProductApi };
